<template lang="html">
  <section class="sub-main take-place column actualities">
		<!-- <patrimonial-short /> -->
		<force-complete-profile-banner v-if="isForceCompleteProfile"/>
		<no-estate-short v-else-if="!isEstate"/>
		<router-view></router-view>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import NoEstateShort from '@/components/NoEstateShort'
import ForceCompleteProfileBanner from '@/components/ForceCompleteProfileBanner'
import PatrimonialShort from '@/components/PatrimonialShort'

export default {
	name: 'Actualities',
	components: {
		PatrimonialShort,
		NoEstateShort,
		ForceCompleteProfileBanner
	},

	computed: {
		...mapGetters({
			isEstate: 'isEstate',
			isForceCompleteProfile: 'isForceCompleteProfile'
		})
	}
}
</script>



// WEBPACK FOOTER //
// src/views/Actualities/index.vue